module.exports = __webpack_public_path__ + "static/media/KinderschutzPolicy.9248a4bd.pdf";